<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">{{form.modal.title}}</h4>
        </div>
        <div class="modal-body">

          <div class="panel-body">
            <div class="row panel-heading">
              <div class="col-sm-12 text-center">
                <form class="form-inline search-fields" @submit.prevent="form.onSiteSearch('siteId')">
                  <div class="form-group">
                    <select class="form-control" id="searchField" name="searchField" v-model="form.siteSearch.field">
                      <option value="site">Site</option>
                      <option value="zone">Zone</option>
                      <option value="location">Location</option>
                      <option value="route">Route</option>
                    </select>
                  </div>
                  <div class="input-group">
                    <input type="search" placeholder="search sites" class="form-control" v-model="form.siteSearch.term">
                    <span class="input-group-addon pointer" v-on:click="form.onSiteSearch('siteId')" title="search"><i class="fa fa-search"></i></span>
                  </div>
                  <i class="fa fa-spinner fa-spin" v-if="siteSearch.loading"></i>
                  <button type="button" class="btn btn-default ml-20" v-if="!siteSearch.loading" v-on:click="newSite">Create new site</button>
                </form>
              </div>
            </div>
          </div>

          <form @submit.prevent="form.onSubmit" @keydown="form.errors.clear($event.target.id)">
            <input type="hidden" name="id" v-model="form.data.id">

            <div class="form-group" :class="{'has-error': form.errors.has('siteId') }">
              <label class="control-label">Site</label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.siteId" v-on:change="setSelected">
                  <option v-for="item in siteSearch.sites" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('siteId')" v-text="form.errors.get('siteId')"></span>
            </div>

            <div class="site-details">
              <div class="row">
                <div class="col-xs-12 col-sm-4 col-sm-offset-2"><strong>Name:</strong> {{ siteSearch.selected.name }}</div>
                <div class="col-xs-12 col-sm-4"><strong>Address:</strong> {{ siteSearch.selected.address }}, {{ siteSearch.selected.city }}, {{ stateName(siteSearch.selected.stateId) }} {{ siteSearch.selected.zip }}</div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-4 col-sm-offset-2"><strong>Zone:</strong> {{ zoneName(siteSearch.selected.zoneId) }}</div>
                <div class="col-xs-12 col-sm-4"><strong>Route:</strong> {{ routeName(siteSearch.selected.routeId) }}</div>
              </div>
            </div>

            <div class="checkbox" :class="{'has-error': form.errors.has('isActive') }">
              <label>
                <input type="checkbox" id="isActive" v-model="form.data.isActive"> Active</label>
              <span class="help-block" v-if="form.errors.has('isActive')" v-text="form.errors.get('isActive')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('countyId') }">
              <label class="control-label">County <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.countyId">
                  <option></option>
                  <option v-for="item in counties" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('countyId')" v-text="form.errors.get('countyId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('routeId') }">
              <label class="control-label">Route <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.routeId">
                  <option></option>
                  <option v-for="item in routes" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('routeId')" v-text="form.errors.get('routeId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('routeOrder') }">
              <label class="control-label">Route Order <span class="optional">(optional; values 1-{{form.data.maxRouteOrder}} are currently valid for this route)</span></label>
              <input type="number" class="form-control" id="routeOrder" v-model.number="form.data.routeOrder">
              <span class="help-block" v-if="form.errors.has('routeOrder')" v-text="form.errors.get('routeOrder')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('foundBy') }">
              <label class="control-label">Found By <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="foundBy" v-model="form.data.foundBy">
              <span class="help-block" v-if="form.errors.has('foundBy')" v-text="form.errors.get('foundBy')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('foundDate') }">
              <label class="control-label">Found Date <span class="optional">(optional)</span></label>
              <date-picker v-model="form.data.foundDate"></date-picker>
              <span class="help-block" v-if="form.errors.has('foundDate')" v-text="form.errors.get('foundDate')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('acreage') }">
              <label class="control-label">Site Acreage <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="acreage" v-model="form.data.acreage">
              <span class="help-block" v-if="form.errors.has('acreage')" v-text="form.errors.get('acreage')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('landowner') }">
              <label class="control-label">Landowner <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="landowner" v-model="form.data.landowner">
              <span class="help-block" v-if="form.errors.has('landowner')" v-text="form.errors.get('landowner')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('permission') }">
              <label class="control-label">Permission <span class="optional">(optional)</span></label>
              <select class="form-control" v-model="form.data.permission">
                <option value="granted">Granted</option>
                <option value="denied">Denied</option>
                <option value="unknown">Unknown</option>
              </select>
              <span class="help-block" v-if="form.errors.has('permission')" v-text="form.errors.get('permission')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('landownerAddress') }">
              <label class="control-label">Landowner Address <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="landownerAddress" v-model="form.data.landownerAddress">
              <span class="help-block" v-if="form.errors.has('landownerAddress')" v-text="form.errors.get('landownerAddress')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('landownerCity') }">
              <label class="control-label">Landowner City <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="landownerCity" v-model="form.data.landownerCity">
              <span class="help-block" v-if="form.errors.has('landownerCity')" v-text="form.errors.get('landownerCity')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('landownerStateId') }">
              <label class="control-label">Landowner State <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.landownerStateId">
                  <option></option>
                  <option v-for="item in states" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('landownerStateId')" v-text="form.errors.get('landownerStateId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('landownerZip') }">
              <label class="control-label">Landowner landownerZip <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="landownerZip" v-model="form.data.landownerZip">
              <span class="help-block" v-if="form.errors.has('landownerZip')" v-text="form.errors.get('landownerZip')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('contactPerson') }">
              <label class="control-label">Contact Person <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="contactPerson" v-model="form.data.contactPerson">
              <span class="help-block" v-if="form.errors.has('contactPerson')" v-text="form.errors.get('contactPerson')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('phoneNumber') }">
              <label class="control-label">Phone Number <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="phoneNumber" v-model="form.data.phoneNumber">
              <span class="help-block" v-if="form.errors.has('phoneNumber')" v-text="form.errors.get('phoneNumber')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('contactDate') }">
              <label class="control-label">Contact Date <span class="optional">(optional)</span></label>
              <date-picker v-model="form.data.contactDate"></date-picker>
              <span class="help-block" v-if="form.errors.has('contactDate')" v-text="form.errors.get('contactDate')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('unincorporated') }">
              <label class="control-label">Unincorporated <span class="optional">(optional)</span></label>
              <select class="form-control" v-model="form.data.unincorporated">
                <option value="unincorporated">Unincorporated</option>
                <option value="in city">In city</option>
              </select>
              <span class="help-block" v-if="form.errors.has('unincorporated')" v-text="form.errors.get('unincorporated')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('habitatId') }">
              <label class="control-label">Habitat 1<span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.habitatId">
                  <option></option>
                  <option v-for="item in habitats" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('habitatId')" v-text="form.errors.get('habitatId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('habitat2Id') }">
              <label class="control-label">Habitat 2 <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.habitat2Id">
                  <option></option>
                  <option v-for="item in habitats" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('habitat2Id')" v-text="form.errors.get('habitat2Id')"></span>
            </div>

            <div class="checkbox" :class="{'has-error': form.errors.has('waterOfUs') }">
              <label>
                <input type="checkbox" id="waterOfUs" v-model="form.data.waterOfUs"> Water Of US</label>
              <span class="help-block" v-if="form.errors.has('waterOfUs')" v-text="form.errors.get('waterOfUs')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('waterId') }">
              <label class="control-label">Water <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.waterId">
                  <option></option>
                  <option v-for="item in waters" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('waterId')" v-text="form.errors.get('waterId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('water2Id') }">
              <label class="control-label">Water 2 <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.water2Id">
                  <option></option>
                  <option v-for="item in waters" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('water2Id')" v-text="form.errors.get('water2Id')"></span>
            </div>

            <div class="checkbox" :class="{'has-error': form.errors.has('nuisanceProgram') }">
              <label>
                <input type="checkbox" id="nuisanceProgram" v-model="form.data.nuisanceProgram"> Nuisance Program</label>
              <span class="help-block" v-if="form.errors.has('nuisanceProgram')" v-text="form.errors.get('nuisanceProgram')"></span>
            </div>

            <div class="checkbox" :class="{'has-error': form.errors.has('isMandatory') }">
              <label>
                <input type="checkbox" id="isMandatory" v-model="form.data.isMandatory"> Site is Mandatory</label>
              <span class="help-block" v-if="form.errors.has('isMandatory')" v-text="form.errors.get('isMandatory')"></span>
            </div>

            <loading-button :loading="form.loading" class="btn btn-primary" :disabled="form.errors.any()">Save</loading-button>
            <button type="button" class="btn btn-default" data-dismiss="modal">cancel</button>
          </form>
        </div>
        <div class="modal-footer">
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal -->
</template>

<script>
  import LoadingButton from '@/components/loading-button';
  import DatePicker from '@/components/date-picker';
  import SitesService from '@/services/SitesService';

  export default {
    name: 'site-form',

    props: ['form', 'contracts', 'counties', 'routes', 'municipalities', 'habitats', 'waters', 'zones'],

    components: {
      LoadingButton,
      DatePicker,
    },

    data() {
      return {
        siteSearch: this.$store.getters.siteSearch
      }
    },

    methods: {
      zoneName(id) {
        return this.$store.getters.zoneNameById(id);
      },
      routeName(id) {
        return this.$store.getters.routeNameById(id);
      },
      stateName(id) {
        return this.$store.getters.stateNameById(id);
      },
      setSelected() {
        this.$store.dispatch('setSiteSearchSelected', this.form.data.siteId);
      },
      newSite() {
        this.form.hideEdit();
        this.$router.push({name: 'data-sites-new'})
      }
    },

    computed: {
      sites() {
        return this.$store.getters.sites;
      },
      counties() {
        return this.$store.getters.counties;
      },
      routes() {
        return this.$store.getters.routes;
      },
      municipalities() {
        return this.$store.getters.municipalities;
      },
      habitats() {
        return this.$store.getters.habitats;
      },
      waters() {
        return this.$store.getters.waters;
      },
      states() {
        return this.$store.getters.states;
      },
      zones() {
        return this.$store.getters.zones;
      },
    },

    mounted() {
      this.form.siteSearch.service = SitesService;
    }

  }

</script>
